export default defineNuxtPlugin(() => {
  const localeCookie = useCookie<string>('i18n_locale', {
    maxAge: 60 * 60 * 24 * 365, // 1 year
    path: '/',
  });
  
  const { locale } = useI18n();
  
  // Initialize locale from cookie immediately
  const savedLocale = localeCookie.value;
  if (savedLocale && (savedLocale === 'en' || savedLocale === 'ar')) {
    locale.value = savedLocale;
  } else if (!localeCookie.value) {
    localeCookie.value = 'en';
  }
  
  // Update HTML attributes
  const updateHtmlAttrs = (loc: string) => {
    document.documentElement.lang = loc;
    document.documentElement.dir = loc === 'ar' ? 'rtl' : 'ltr';
  };
  
  updateHtmlAttrs(locale.value);
  
  // Watch for locale changes and persist to cookie
  watch(locale, (newLocale) => {
    if (newLocale && (newLocale === 'en' || newLocale === 'ar')) {
      localeCookie.value = newLocale;
      updateHtmlAttrs(newLocale);
    }
  });
});

